import React from "react";
import styles from "./ExperienceBox.module.css";
import SkillWidget from "./SkillWidget";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useScrollAnimation } from "../hooks/useScrollAnimation";

const ExperienceBox = (props) => {
  const [ref, isVisible] = useScrollAnimation({ threshold: 0.1, once: true });
  const skillWidgets = props.skills.map((skill, index) => (
    <SkillWidget key={index} skill={skill} index={index} />
  ));

  const addLink = (textAndLinkList, description) => {
    const text = textAndLinkList[0];
    const link = textAndLinkList[1];
    let splitText = description.split(text);
    return (
      <p className={styles.descriptionStyle}>
        {splitText[0]}{" "}
        <a href={link} rel="noreferrer" target="_blank">
          {text}
        </a>{" "}
        {splitText[1]}
      </p>
    );
  };

  return (
    <Container>
      <div 
        ref={ref}
        className={`${styles.experienceBoxContainer} ${isVisible ? styles.animateIn : ''}`}
      >
        <Row>
          <Col sm={4}>
            <div className={styles.dateContainer}>
              {props.logo && (
                <div className={styles.logoContainer}>
                  <img 
                    src={props.logo} 
                    alt={`${props.company} logo`}
                    className={styles.companyLogo}
                    onError={(e) => {
                      console.warn(`Failed to load logo for ${props.company}:`, props.logo);
                      e.target.style.display = 'none';
                    }}
                    onLoad={() => {
                      console.log(`Successfully loaded logo for ${props.company}`);
                    }}
                    loading="lazy"
                  />
                </div>
              )}
              <div className={styles.dateLocationStyle}>
                <div className={styles.showMobile}>
                  {props.date} {props.location}
                </div>
                <div className={styles.hideMobile}>
                  <div>{props.date}</div>
                  <div>{props.location}</div>
                </div>
              </div>
            </div>
          </Col>
          <Col sm={8}>
            <div className={styles.positionCompanyStyle}>
              {props.position} · {props.company}
            </div>
            {props.link ? (
              addLink(props.link, props.description)
            ) : (
              <p className={styles.descriptionStyle}>{props.description}</p>
            )}

            <div className={styles.skillsContainer}>{skillWidgets}</div>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default ExperienceBox;
